'use client'

import { AuthContext } from "@/context/authContext"
import api from "@/util/api"
import React, { HTMLInputAutoCompleteAttribute, HTMLInputTypeAttribute, ReactNode } from "react"
import { FormEvent, useContext, useEffect, useRef, useState } from "react"
import Icon from "../etc/icon"
import LoginInput from "../etc/loginInput"
import { SignContext } from "@/context/signContext"
import ProfileLayout from "../etc/profile"
import { with_comma } from "@/util/comma"
import { MessageContext } from "@/context/messageContext"
import { BetContext } from "@/context/BetContext"
import customAlert from "@/util/customAlert"
import { NavContext } from "@/context/navContext"
import SwitchTheme from "../etc/themeSwitch"
import { useTranslations } from "next-intl"

export default function UserLayout() {
    const { user } = useContext(AuthContext)

    return (
        <div className="user-info-container">
            <div><SwitchTheme /></div>
            <div className="user-info">
                {
                    !user.is_authenticated
                        ? <NonLogin />
                        : <LoginAuth />
                }
            </div>
        </div>
    )
}

function NonLogin() {
    const { login } = useContext(AuthContext)
    const { SetSignUpShow } = useContext(SignContext)

    const t = useTranslations('Text')
    const a = useTranslations('Sentence')

    const [username, setUsername] = useState<string>("")
    const [password, setPassword] = useState<string>("")

    const formRef = useRef<HTMLFormElement>(null)

    async function handleSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()

        if (!username) {
            customAlert(a('Invalid_Username'), 'warning');
            return false;
        }
        else if (!password) {
            customAlert(a('Invalid_Password'), 'warning');
            return false;
        }

        const formData = new FormData()
        formData.set('username', username)
        formData.set('password', password)

        api('/api/user/login/',
            { method: "POST", body: formData })
            .then(res => res.json())
            .then(({data, status_code, message}) => {
                if(status_code == 200){
                    login(data.user)
                }else{
                    customAlert(message, 'warning')
                }
            })
            .catch((error: Response)=> {
                customAlert(a('CheckYourID&Password'), 'error')
                console.error(error)
            })
    }

    return (
        <div className="non-login">
            <p>{t('로그인')}</p>
            <div className="input-form">
                <form action="#" ref={formRef}
                    onSubmit={e => handleSubmit(e)} >
                    <div className="form-layout">
                        <LoginInput type="text" name="username" placeholder={t('아이디')} onChange={e => setUsername(e.currentTarget.value)} />
                        <LoginInput type="password" name="password" placeholder={t('비밀번호')} onChange={e => setPassword(e.currentTarget.value)} />
                    </div>
                    <button type="submit" >{t('로그인')}</button>
                </form>
            </div>
            <div className="other-btns">
                <p onClick={e=> SetSignUpShow(true)}>{t('회원가입')}</p>
                <p onClick={e=> customAlert(a('AskedCustomerCenter'), 'warning')}>{t('비밀번호 찾기')}</p>
            </div>
        </div>
    )
}



function LoginAuth() {
    const { user, logout, messages } = useContext(AuthContext)
    const { SetMypageShow } = useContext(SignContext)
    const { SetMessageShow } = useContext(MessageContext)
    const { setBetDetailShow } = useContext(BetContext)
    const { movePage } = useContext(NavContext)

    const t = useTranslations('Text')
    
    // useEffect(()=> {
    //     console.log("*****", user)
    // }, [user])
    if (!user.is_authenticated) return null;
    return (

        <div className={`login-auth-new`}>
            <div className={`flex center`}>
                <div className={`img`}><ProfileLayout /></div>
                <div className={`info`}>
                    {/* <div className={`flex center`}>
                        <div className={`w-20-per`}>아이디</div>
                        <div className={`w-80-per p-l-10`}>{user.id}</div>
                    </div>
                    <div className={`flex center`}>
                        <div className={`w-20-per`}>닉네임</div>
                        <div className={`w-80-per p-l-10`}>{user.nickname}</div>
                    </div> */}
                    <div className="flex intro">
                        <span>{t('안녕하세요')}</span>
                    </div>
                    <div className="flex nickname">
                        <div>{user.nickname} <span>{t('님')}</span></div>
                    </div>
                    <div className={`flex center etc`}>
                        <div className={`w-33-per`}>
                            <div>{t('레벨')}</div>
                            <div>{with_comma(user.level)}</div>
                        </div>
                        <div className={`w-33-per`}>
                            <div>{t('경험치')}</div>
                            <div>{with_comma(user.exp)} EXP</div>
                        </div>
                        <div className={`w-33-per`}>
                            <div>{t('포인트')}</div>
                            <div>{with_comma(user.point)} P</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="btns flex center">
                {/* <button onClick={e => SetMypageShow(true)}>마이페이지</button> */}
                <button className={`w-32-per`} onClick={e => movePage('/mypage/')}>{t('마이페이지')}</button>
                <button className={`w-32-per`} onClick={e => SetMessageShow(true)}>{t('쪽지')} <span>({messages.unread_count})</span></button>
                {/* <button onClick={e => setBetDetailShow(true)}>베팅내역</button> */}
                <button className={`w-32-per`} onClick={e => logout()}>{t('로그아웃')}</button>
            </div>
        </div>
        // <div className="login-auth">
        //     <div className="inner">
        //         <ProfileLayout />
        //         <div className="info">
        //             <div className="info-row">
        //                 <p>{user.nickname}</p>
        //             </div>
        //             <div className="info-row">
        //                 <p>레벨</p>
        //                 <span>{with_comma(user.level)}</span>
        //             </div>
        //             <div className="info-row">
        //                 <p>경험치</p>
        //                 <span>{with_comma(user.exp)} EXP</span>
        //             </div>
        //             <div className="info-row">
        //                 <p>포인트</p>
        //                 <span>{with_comma(user.point)} P</span>
        //             </div>
        //             {/* <div className="info-row">
        //                 <p>수익랭킹: {user.rank_revenue}위</p>
        //                 /
        //                 <p>활동랭킹: {user.rank_activity}위</p>
        //             </div> */}
        //         </div>
        //     </div>
        //     <div className="btns">
        //         <button onClick={e => SetMypageShow(true)}>마이페이지</button>
        //         <button onClick={e => SetMessageShow(true)}>쪽지</button>
        //         <button onClick={e => setBetDetailShow(true)}>나의베팅내역</button>
        //         <button onClick={e => logout()}>로그아웃</button>
        //     </div>
        // </div>
    )
}